export const vehicleColumns = (t: any) => [
    {
      key: "brand",
      name: t('vehicles.columns.brand'),
      fieldName: "brand",
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "model",
      name: t('vehicles.columns.model'),
      fieldName: "model",
      minWidth: 100,
      maxWidth: 100,
    },
    {
      key: "registerNumber",
      name: t('vehicles.columns.registerNumber'),
      fieldName: "registerNumber",
      minWidth: 200,
      maxWidth: 250,
    },
  ];